<template>
	<div class="resizable-dialog position-fixed top-0 right-0 ma-2"
		:style="{ zIndex: 2000, height: dialogHeight, width: dialogWidth }" ref="dialog">
		<v-card class="pa-1 d-flex flex-column fill-height" style="height: 100%">
			<v-card-title class="d-flex justify-end pa-0 ma-0">
				<v-container>

					<v-tabs color="primary" v-model="selectedMissionId" grow>


						<v-tab v-for="mission in missions" :key="mission.id"> {{ mission.name }}
						</v-tab>



					</v-tabs>
					<v-window v-model="selectedMissionId">
						<v-window-item>
							<v-tabs v-model="selectedVehicleId">
								<v-tab :color="vehicle.boat_mark_color" max-height="40px"
									v-for="vehicle in missions[selectedMissionId]?.vehicles ?? []" :key="vehicle.id">
									{{ vehicle.name }}
								</v-tab>
							</v-tabs>
						</v-window-item>
					</v-window>
				</v-container>

				<v-btn icon="mdi-close" size="small" variant="plain" @click="emits('close')" class="mt-n2 me-n2" />
			</v-card-title>

			<!-- Contenedor con flex-grow para contenido -->
			<v-card-text class="flex-grow-1 d-flex flex-column overflow-hidden" style="min-height: 0;">
				<p v-if="missions.length === 0">No missions are currently running.</p>
				<div class="mission-container flex-grow-1 d-flex flex-column" style="min-height: 0;">
					<BoatInfoElement :key="selectedVehicleId"
						:vehicle="missions[selectedMissionId]?.vehicles[selectedVehicleId]" class="flex-grow-1"
						style="min-height: 0;" />
				</div>



			</v-card-text>
		</v-card>

		<div class="resizer"></div>
	</div>
</template>

<script setup>
import { ref, onMounted, watch, computed } from 'vue'
import { usePlayMissionStore } from '@/store/playMission'
import BoatInfoElement from '@/components/boatInfo/BoatInfoElement'
import { storeToRefs } from 'pinia'

const emits = defineEmits(['close'])

const playMissionStore = usePlayMissionStore()
const { missions } = storeToRefs(playMissionStore)

const selectedMissionId = ref(null)
const selectedVehicleId = ref(null)

watch(missions, (newMissions) => {
	if (newMissions.length > 0) {
		selectedMissionId.value = newMissions[0].id
		selectedVehicleId.value = newMissions[0].vehicles[0]?.id ?? null
		console.log(selectedMissionId.value, selectedVehicleId.value)
	}
}, { immediate: true })





const dialog = ref(null)
const dialogHeight = ref('350px')
const dialogWidth = ref('400px')

onMounted(() => {
	const el = dialog.value
	const resizer = el.querySelector('.resizer')


	let startY, startHeight

	const initResize = (e) => {
		startY = e.clientY
		startHeight = el.offsetHeight

		document.body.classList.add('no-select') // ✅ evita selección de texto

		document.addEventListener('mousemove', doResize)
		document.addEventListener('mouseup', stopResize)
	}

	const doResize = (e) => {
		const newHeight = Math.min(Math.max(300, startHeight + e.clientY - startY), 600);
		dialogHeight.value = `${newHeight}px`
	}

	const stopResize = () => {
		document.body.classList.remove('no-select') // ✅ vuelve a permitir selección

		document.removeEventListener('mousemove', doResize)
		document.removeEventListener('mouseup', stopResize)
	}

	resizer.addEventListener('mousedown', initResize);
})
</script>

<style>
.resizable-dialog {
	background-color: white;
	border: 1px solid #ccc;
	overflow: hidden;
	box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
	border-radius: 8px;
}

.resizer {
	width: 100%;
	height: 8px;
	background: rgba(0, 0, 0, 0.1);
	position: absolute;

	bottom: 0;
	cursor: n-resize;
	z-index: 10;
	border-bottom-right-radius: 8px;
}

.no-select {
	user-select: none;
}
</style>
